import EngineRequests from '../../../utils/requests/engineVersion';

export default {

    async queryVersion({ commit }) {
        const data = await EngineRequests.getEngineInfo();
        commit('setVersion', data.version);
    }
};
